import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./styles.scss";

const Loading = (): JSX.Element => {
  const size = 10;

  return (
    <div className="loading">
      <div className="loading-overlay">
        <div
          className="loading-spinner"
          style={{
            marginTop: (-16 * size) / 2,
            marginLeft: (-16 * size) / 2,
          }}
        >
          <FontAwesomeIcon icon={faSpinner} spin size={`${size}x`} />
        </div>
      </div>
    </div>
  );
};

export default Loading;
